var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M209.796,207.182c-0.008,0.008-0.017,0.013-0.026,0.021L13.474,0H0v88.276l199.711,130.845   C202.59,214.735,206.001,210.775,209.796,207.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M189.327,262.901c-0.238-2.301-0.696-4.537-0.696-6.901s0.458-4.6,0.696-6.901l-0.001,0.004   L0,229.517v52.966l189.326-19.586L189.327,262.901z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "245.53,189.687 245.53,189.687 245.528,189.687  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,188.632c3.587,0,7.036,0.515,10.47,1.055L296.421,0h-80.842l29.951,189.687   C248.964,189.146,252.413,188.632,256,188.632z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "266.472,189.687 266.47,189.687 266.47,189.687  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M302.204,207.182c3.795,3.593,7.206,7.554,10.086,11.939L512,88.276V0h-13.474L302.229,207.202   C302.221,207.195,302.212,207.189,302.204,207.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M312.289,292.879c-2.879,4.386-6.29,8.346-10.086,11.939c0.008-0.007,0.017-0.013,0.026-0.021   L498.526,512H512v-88.276L312.289,292.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M322.673,249.099c0.238,2.301,0.696,4.537,0.696,6.901c0,2.364-0.458,4.6-0.696,6.901l0.001-0.004   L512,282.483v-52.966l-189.326,19.585L322.673,249.099z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "245.528,322.313 245.53,322.313 245.53,322.313  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256,323.368c-3.587,0-7.036-0.515-10.47-1.055L215.579,512h80.842L266.47,322.313   C263.036,322.854,259.587,323.368,256,323.368z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "266.47,322.313 266.47,322.313 266.472,322.313  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M209.796,304.818c-3.795-3.593-7.206-7.553-10.086-11.939L0,423.724V512h13.474l196.297-207.202   C209.779,304.805,209.788,304.811,209.796,304.818z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 256,
    cy: 256,
    r: 35.31
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/MK.7cbefafc25ba64597504862360f520d7.svg";
export { ForwardRef as ReactComponent };